module.exports = __webpack_public_path__ + "img/bathroom_full.a5e6041a.jpg";